// extracted by mini-css-extract-plugin
export default {"thumbnail":"ReservationPage_thumbnail__vo1Th","summary_list":"ReservationPage_summary_list__5deHg","cancellation_policy":"ReservationPage_cancellation_policy__jzH-M"};